import React, { useEffect, useState } from "react";
import Table from "../../../../../core/common/dataTable/index";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { Button, Checkbox, CheckboxChangeEvent, Dropdown, Menu, Select, Spin } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const MetaOnBoardStudents = () => {
    const { Option } = Select;
    const routes = all_routes;
    const navigate = useNavigate();
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState<string>("");
    const [pageSize, setPageSize] = useState<number>(() => {
        return Number(localStorage.getItem("metaOnboardStudentsPageSize")) || 10;
    });

    const [currentPage, setCurrentPage] = useState<number>(() => {
        return Number(localStorage.getItem("metaOnboardStudentsCurrentPage")) || 1;
    });
    useEffect(() => {
        localStorage.setItem("metaOnboardStudentsPageSize", String(pageSize));
    }, [pageSize]);

    useEffect(() => {
        localStorage.setItem("metaOnboardStudentsCurrentPage", String(currentPage));
    }, [currentPage]);
    const [totalCount, setTotalCount] = useState(0);
    const [searchText, setSearchText] = useState<string>("");
    const [data, setData] = useState<any[]>([]);
    const [buildingCategories, setBuildingCategories] = useState<any[]>(
        [],
    );
    const [branchDropdown, setBranchDropdown] = useState<any[]>([]);
    const [classDropdown, setClassDropdown] = useState<any[]>([]);
    const [states, setStates] = useState<any[]>([]);
    const [admissionStatus, setAdmissionStatus] = useState<any[]>([]);
    const [orientationDropdown, setOrientationDropdown] = useState<any[]>([]);
    const [buildingCategoriesDropdown, setBuildingCategoriesDropdown] = useState<any[]>([]);
    const [statesDropdown, setStatesDropdown] = useState<any[]>([]);
    const [branchesDropdown, setBranchesDropdown] = useState<any[]>([]);
    const [residentialStatusDropdown, setResidentialStatusDropdown] = useState<any[]>([]);
    const [examProgramDropdown, setExamProgramDropdown] = useState<any[]>([]);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [AsignshowCard, setAsignShowCard] = useState(false);
    const [unAssignLoading, setUnAssignLoading] = useState(false);
    const [agentsLoading, setAgentsLoading] = useState(false);
    const [selectedAgent, setSelectedAgent] = useState<string[]>([]);
    const [agentsDropdown, setAgentsDropdown] = useState<any[]>([]);
    const [agentListDropdown, setAgentListDropdown] = useState<any[]>([]);
    const [filters, setFilters] = useState(() => {
        const savedFilters = localStorage.getItem("metaOnBoardStudents_filters");
        return savedFilters
            ? JSON.parse(savedFilters)
            : {
                branch: "",
                building_category: "",
                state: "",
                residential_status: "",
                exam_program: "",
                meta_login_status: null as boolean | null,
                agent: "",
            };
    });
    useEffect(() => {
        console.log("selectedrows", selectedRowKeys);
    }, [selectedRowKeys]);
    useEffect(() => {
        localStorage.setItem("metaOnBoardStudents_filters", JSON.stringify(filters));
    }, [filters]);
    const [appliedFilters, setAppliedFilters] = useState(filters);

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject,
        );
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    useEffect(() => {
        console.log("login", appliedFilters.meta_login_status);
    }, [filters]);

    const fetchBuildingCategoriesDropdown = async () => {
        try {
            const res = await fetch(
                `${webApi}/meta_onboard/building_categories_dropdown_for_student_list/`,
                options,
            );
            const data = await res.json();
            setBuildingCategoriesDropdown(data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchStatesDropdown = async () => {
        try {
            const res = await fetch(
                `${webApi}/meta_onboard/states_dropdown_for_student_list/`,
                options,
            );
            const data = await res.json();
            setStatesDropdown(data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchBranchesDropdown = async () => {
        try {
            const res = await fetch(
                `${webApi}/meta_onboard/branches_dropdown_for_student_list/`,
                options,
            );
            const data = await res.json();
            setBranchesDropdown(data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchResidentialStatusDropdown = async () => {
        try {
            const res = await fetch(
                `${webApi}/meta_onboard/residential_status_dropdown_for_student_list/`,
                options,
            );
            const data = await res.json();
            setResidentialStatusDropdown(data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchExamProgramDropdown = async () => {
        try {
            const res = await fetch(
                `${webApi}/meta_onboard/exam_program_dropdown_for_student_list/`,
                options,
            );
            const data = await res.json();
            setExamProgramDropdown(data);
        } catch (err) {
            console.error(err);
        }
    };
    const fetchAgentsDataForAssignmnet = async () => {
        setAgentsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/meta_onboard/agent_dropdown_for_meta_onboard_student_assignment/`,
                options
            );
            const data = await response.json();
            setAgentsDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const fetchAgentListDropdown = async () => {
        setAgentsLoading(true);
        try {
            const response = await fetch(
                `${webApi}/meta_onboard/agents_dropdown_for_student_list/`,
                options
            );
            const data = await response.json();
            setAgentListDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        } finally {
            setAgentsLoading(false);
        }
    };



    useEffect(() => {
        fetchBuildingCategoriesDropdown();
        fetchStatesDropdown();
        fetchBranchesDropdown();
        fetchResidentialStatusDropdown();
        fetchExamProgramDropdown();
        fetchAgentsDataForAssignmnet();
        fetchAgentListDropdown();
    }, []);

    useEffect(() => {
        if (
            !checkPermission("view_metastudentdetails", "metastudentdetails")
        ) {
            navigate(routes.crmLandingPage);
            return;
        }
        fetchData();
    }, [userPermissions, appliedFilters, currentPage, searchText, pageSize]);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const queryParams = new URLSearchParams({
                branch: appliedFilters.branch || "",
                building_category: appliedFilters.building_category || "",
                state: appliedFilters.state || "",
                search: searchText || "",
                residential_status: appliedFilters.residential_status || "",
                exam_program: appliedFilters.exam_program || "",
                meta_login_status:
                    appliedFilters.meta_login_status !== null &&
                        appliedFilters.meta_login_status !== undefined
                        ? String(appliedFilters.meta_login_status)
                        : "",
                page: String(currentPage),
                agent: appliedFilters.agent || "",
            });

            queryParams.append("page_size", String(pageSize));
            const response = await fetch(
                `${webApi}/meta_onboard/meta_students/?${queryParams.toString()}`,
                options,
            );
            const result = await response.json();
            if (!response.ok) {
                if (result.code === "token_not_valid") {
                    navigate(routes.crmLandingPage);
                    return;
                }
                throw new Error(result.detail || "Failed to fetch teachers");
            }
            setData(result.results || []);
            setTotalCount(result.total_count || 0);
        } catch (error) {
            console.error("Students fetch error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    //Reusable function to display applied filters
    const renderFilterTag = (
        value: string | null,
        filterKey: keyof typeof appliedFilters,
    ) => {
        if (!value) return null;

        return (
            <span
                style={{
                    marginLeft: 8,
                    display: "inline-flex",
                    alignItems: "center",
                }}
            >
                <span style={{ color: "#1890ff", marginRight: 4 }}>
                    ({value})
                </span>

                <CloseCircleOutlined
                    onClick={() => {
                        const updatedFilters = {
                            ...filters,
                            [filterKey]:
                                filterKey === "meta_login_status" ? null : "",
                        };

                        setFilters(updatedFilters);
                        setAppliedFilters(updatedFilters);
                    }}
                    style={{
                        color: "red",
                        cursor: "pointer",
                    }}
                />
            </span>
        );
    };

    const handleSelect = (
        student_id: any,
        selectedRowKeys: string[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        const selectedIds = [...selectedRowKeys];
        const index = selectedIds.indexOf(student_id);
        if (index >= 0) {
            selectedIds.splice(index, 1);
        } else {
            selectedIds.push(student_id);
        }
        setSelectedRowKeys(selectedIds);
    };

    const columns = [
        {
            title: "Action",
            dataIndex: "action",
            render: (_text: any, record: { student_id: any }) => (
                <Checkbox
                    checked={selectedRowKeys.includes(record.student_id)}
                    onChange={() =>
                        handleSelect(record.student_id, selectedRowKeys, setSelectedRowKeys)
                    }
                />
            ),
            key: "action",
            // align: "center",
        },
        {
            title: (
                <span>
                    Building Category
                    {renderFilterTag(
                        buildingCategoriesDropdown.find(
                            (item) =>
                                String(item.building_category_id) === String(appliedFilters.building_category),
                        )?.name || null,
                        "building_category",
                    )}
                </span>
            ),
            dataIndex: "building_category",
            key: "building_category",
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
        },
        {
            title: (
                <span>
                    Admission Number
                    {/* {renderFilterTag(
                        FILTERS.find(
                            (item) =>
                                String(item.value) === String(appliedFilters.building_category),
                        )?.label || null,
                        "building_category",
                    )} */}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "scs_number",
            key: "scs_number",
        },

        {
            title: (
                <span>
                    Name
                    {renderFilterTag(
                        branchDropdown.find(
                            (item) =>
                                String(item.branch_id) === String(appliedFilters.branch),
                        )?.name || null,
                        "branch",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "name",
            key: "name",
        },



        {
            title: (
                <span>
                    State
                    {renderFilterTag(
                        statesDropdown.find(
                            (item) =>
                                String(item.state_id) ===
                                String(appliedFilters.state),
                        )?.name || null,
                        "state",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "state",
            key: "state",
        },
        {
            title: (
                <span>
                    Branch
                    {renderFilterTag(
                        branchesDropdown.find(
                            (item) =>
                                String(item.branch_id) === String(appliedFilters.branch),
                        )?.name || null,
                        "branch",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "branch",
            key: "branch",
        },
        {
            title: (
                <span>
                    Student Type
                    {renderFilterTag(
                        residentialStatusDropdown.find(
                            (item) =>
                                String(item.id) === String(appliedFilters.residential_status),
                        )?.name || null,
                        "residential_status",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "residential_status",
            key: "residential_status",
        },
        {
            title: (
                <span>
                    Exam Program
                    {renderFilterTag(
                        examProgramDropdown.find(
                            (item) =>
                                String(item.id) === String(appliedFilters.exam_program),
                        )?.name || null,
                        "exam_program",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "exam_program",
            key: "exam_program",
        },
        {
            title: (
                <span>
                    Login Status
                    {renderFilterTag(
                        appliedFilters.meta_login_status === true
                            ? "Yes"
                            : appliedFilters.meta_login_status === false
                                ? "No"
                                : null,
                        "meta_login_status",
                    )}
                </span>
            ),
            render: (
                _text: boolean,
                record: { student_id: any; no_of_attempts: number }
            ) => (
                <Link
                    to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}
                >
                    {_text ? "Yes" : "No"}
                </Link>
            ),
            dataIndex: "meta_login_status",
            key: "meta_login_status",
        },
        {
            title: (
                <span>
                    Last Login
                    {/* {renderFilterTag(
                        adaption_type.find(
                            (item) =>
                                String(item.value) === String(appliedFilters.adaption_type),
                        )?.label || null,
                        "adaption_type",
                    )} */}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "meta_last_login_time",
            key: "meta_last_login_time",
        },
        {
            title: (
                <span>
                    Agent
                    {renderFilterTag(
                        agentListDropdown.find(
                            (item) =>
                                String(item.id) === String(appliedFilters.agent),
                        )?.name || null,
                        "agent",
                    )}
                </span>
            ),
            render: (
                _text: any,
                record: { student_id: any; no_of_attempts: number },
            ) => (
                <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
                    {_text}
                </Link>
            ),
            dataIndex: "agent",
            key: "agent",
        },
        // {
        //     title: (
        //         <span>
        //             Orientation
        //             {renderFilterTag(
        //                 classDropdown.find(
        //                     (item) =>
        //                         String(item.class_name_id) === String(appliedFilters.class_name),
        //                 )?.name || null,
        //                 "class_name",
        //             )}
        //         </span>
        //     ),
        //     render: (
        //         _text: any,
        //         record: { student_id: any; no_of_attempts: number },
        //     ) => (
        //         <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
        //             {_text}
        //         </Link>
        //     ),
        //     dataIndex: "orientation",
        //     key: "orientation",
        // },
        // {
        //     title: (
        //         <span>
        //             Class
        //             {/* {renderFilterTag(
        //     adaption_type.find(
        //       (item) =>
        //         String(item.value) === String(appliedFilters.adaption_type),
        //     )?.label || null,
        //     "adaption_type",
        //   )} */}
        //         </span>
        //     ),
        //     // render: (
        //     //   _text: any,
        //     //   record: { student_id: any; no_of_attempts: number },
        //     // ) => (
        //     //   <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
        //     //     {_text}
        //     //   </Link>
        //     // ),
        //     dataIndex: "student_class",
        //     key: "student_class",
        // },
        //  {
        //     title: (
        //         <span>
        //             Admission Status
        //             {/* {renderFilterTag(
        //     adaption_type.find(
        //       (item) =>
        //         String(item.value) === String(appliedFilters.adaption_type),
        //     )?.label || null,
        //     "adaption_type",
        //   )} */}
        //         </span>
        //     ),
        //     // render: (
        //     //   _text: any,
        //     //   record: { student_id: any; no_of_attempts: number },
        //     // ) => (
        //     //   <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
        //     //     {_text}
        //     //   </Link>
        //     // ),
        //     dataIndex: "admission_status",
        //     key: "admission_status",
        // },
        // {
        //     title: "Section",
        //     dataIndex: "section",
        //     key: "section",
        //     render: (
        //         _text: any,
        //         record: { student_id: any; no_of_attempts: number },
        //     ) => (
        //         <Link to={`${routes.addOrUpdateMetaOnBoardTicket}?id=${record.student_id}&r1=1`}>
        //             {_text}
        //         </Link>
        //     ),
        // },


    ];

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
    };

    const handleApplyClick = () => {
        setAppliedFilters(filters);
        setCurrentPage(1);
        setShowFilter(false);
    };
    const handleResetClick = () => {
        const emptyFilters = {
            branch: "",
            building_category: "",
            state: "",
            residential_status: "",
            exam_program: "",
            meta_login_status: null as boolean | null,
            agent: "",

        };
        localStorage.removeItem("metaOnBoardStudents_filters");
        setFilters(emptyFilters);
        setAppliedFilters(emptyFilters);
        setSearchText("");
        setCurrentPage(1);
        setShowFilter(false);
    };

    const handleSelectAll = (
        e: CheckboxChangeEvent,
        data: { student_id: any }[],
        setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
    ) => {
        if (e.target.checked) {
            const allIds = data.map((item) => item.student_id);
            setSelectedRowKeys(allIds);
        } else {
            setSelectedRowKeys([]);
        }
    };

    const handleAgentUnAssignment = async (
        type: "agent" | "trainer" | "renewal_agent"
    ) => {
        setUnAssignLoading(true);

        try {
            let endpoint = `${webApi}/meta_onboard/assign_meta_student_agent/`;

            const response = await fetch(endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify({
                    student_ids: selectedRowKeys,
                    agent_id: 0,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message);
            }

            setSelectedRowKeys([]);
            fetchData();
        } catch (error) {
            console.error(error);
        } finally {
            setUnAssignLoading(false);
        }
    };

    const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setAgentsLoading(true);
        try {
            const endpoint = `${webApi}/meta_onboard/assign_meta_student_agent/`

            const response = await fetch(
                endpoint,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        student_ids: selectedRowKeys,
                        agent_id: selectedAgent,
                        // target_date_: targetDate,
                    }),
                }
            );

            const data = await response.json();
            if (!response.ok) {

                throw new Error("Failed to assign agent");
            }

            console.log("Agent assigned successfully", data);

            setSelectedRowKeys([]);
            setSelectedAgent([]);
            // setTargetDate("");
            setAsignShowCard(false);
            fetchData();
        } catch (error) {
            console.error("Failed to assign agent", error);
        } finally {
            setAgentsLoading(false);
        }
    };

    const handleSelectChange = (value: string[]) => {
        setSelectedAgent(value);
    };


    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Meta OnBoard Students</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    {/* <li className="breadcrumb-item">
                                        <Link to={routes.SEDDashBoard}>Dashboard</Link>
                                    </li> */}
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Students
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {/* <div className="mb-2">
                   {checkPermission("add", "summercamppriority") && (
                     <Link to={routes.SummerCampAddPriorities} className="btn btn-primary">
                       <i className="ti ti-square-rounded-plus-filled me-2" />
                       Add Priority
                     </Link>
                   )}
                 </div> */}
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Students List</h4>

                            <div className="d-flex align-items-center flex-wrap ms-auto">
                                {checkPermission("assign_agent_to_meta_student", "metastudentdetails") && (
                                    <>
                                        <Checkbox
                                            indeterminate={
                                                selectedRowKeys.length > 0 &&
                                                selectedRowKeys.length < data.length
                                            }
                                            checked={
                                                data.length > 0 &&
                                                selectedRowKeys.length === data.length
                                            }
                                            onChange={(e) =>
                                                handleSelectAll(e, data, setSelectedRowKeys)
                                            }
                                        >
                                            Select All
                                        </Checkbox>

                                        <button
                                            className="btn btn-primary"
                                            onClick={() => setAsignShowCard(true)}
                                            disabled={selectedRowKeys.length === 0}
                                            style={{
                                                marginLeft: "10px",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            Assign Agent
                                        </button>
                                    </>
                                )}
                                {checkPermission("assign_agent_to_meta_student", "metastudentdetails") && (

                                    <button
                                        className="btn btn-primary me-1"
                                        style={{ marginLeft: "10px", marginBottom: "5px", }}
                                        disabled={selectedRowKeys.length === 0 || unAssignLoading}
                                        onClick={() => handleAgentUnAssignment("agent")}
                                    >
                                        {unAssignLoading ? (
                                            <i className="spinner-border spinner-border-sm"></i>
                                        ) : (
                                            <>Un Assign</>
                                        )}
                                    </button>

                                )}
                                {/* )} */}
                            </div>
                            <div className="mb-1">
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={() => setShowFilter(!showFilter)}
                                >
                                    Filters
                                </button>
                                {showFilter && (
                                    <div
                                        className="card mt-3 shadow-sm"
                                        style={{
                                            width: "500px",
                                            position: "absolute",
                                            right: 0,
                                            zIndex: 1000,
                                            borderRadius: "12px",
                                        }}
                                    >
                                        <form>
                                            {/* Header */}
                                            <div className="d-flex align-items-center border-bottom p-3">
                                                <h4 className="mb-0 me-auto">Filter</h4>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowFilter(false)}
                                                />
                                            </div>

                                            {/* Body */}
                                            <div className="p-3">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Building Category</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Building Category"
                                                                value={filters.building_category}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        building_category: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {buildingCategoriesDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.building_category_id}
                                                                        value={d.building_category_id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">State</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select State"
                                                                value={filters.state}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        state: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {statesDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.state_id}
                                                                        value={d.state_id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Branch</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Branch"
                                                                value={filters.branch}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        branch: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {branchesDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.branch_id}
                                                                        value={d.branch_id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Student Type</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Residential Status"
                                                                value={filters.residential_status}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        residential_status: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {residentialStatusDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.id}
                                                                        value={d.id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Exam Program</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Exam Program"
                                                                value={filters.exam_program}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        exam_program: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {examProgramDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.id}
                                                                        value={d.id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Login Status</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Login Status"
                                                                value={filters.meta_login_status}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        meta_login_status: value ?? null,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                <Option key="true" value={true}>
                                                                    Yes
                                                                </Option>
                                                                <Option key="false" value={false}>
                                                                    No
                                                                </Option>
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">Agent</label>
                                                            <Select
                                                                showSearch
                                                                allowClear
                                                                placeholder="Select Agent"
                                                                value={filters.agent}
                                                                onChange={(value) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        agent: value,
                                                                    })
                                                                }
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    (option?.children as unknown as string)
                                                                        .toLowerCase()
                                                                        .includes(input.toLowerCase())
                                                                }
                                                            >
                                                                {agentListDropdown.map((d) => (
                                                                    <Option
                                                                        key={d.id}
                                                                        value={d.id}
                                                                    >
                                                                        {d.name}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Footer */}
                                            <div className="p-3 border-top d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-light me-3"
                                                    onClick={handleResetClick}
                                                >
                                                    Reset
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={handleApplyClick}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={data}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "25", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                    searchText={searchText}
                                />
                            )}
                        </div>
                    </div>
                    {AsignshowCard && (
                        <>
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "rgba(0,0,0,0.5)",
                                    zIndex: 1049,
                                }}
                            />
                            <div
                                className="card"
                                style={{
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "20%",
                                    boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                                    borderRadius: "10px",
                                    zIndex: 1050,
                                    backgroundColor: "#f9f9f9",
                                    padding: "20px",
                                }}
                            >
                                <form onSubmit={handleAgentAssignment}>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                {/* Assignment type dropdown */}

                                                {/* Conditional dropdown based on assignment type */}

                                                <div className="mb-3">
                                                    <label
                                                        className="form-label"
                                                        style={{
                                                            paddingBottom: "10px",
                                                            fontWeight: "bold",
                                                            color: "#555",
                                                        }}
                                                    >
                                                        Select Agent
                                                    </label>
                                                    {agentsLoading ? (
                                                        <Spin />
                                                    ) : (
                                                        <Select
                                                            placeholder="Select Agent"
                                                            value={selectedAgent}
                                                            onChange={handleSelectChange}
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            filterOption={(input, option) => {
                                                                if (!option || !option.children) return false;
                                                                const label = option.children as unknown as string;
                                                                return label.toLowerCase().includes(input.toLowerCase());
                                                            }}
                                                        >
                                                            {agentsDropdown.map((agent) => (
                                                                <Option key={agent.id} value={agent.id}>
                                                                    {agent.name}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <Button
                                            className="btn btn-light me-2"
                                            onClick={() => {
                                                setAsignShowCard(false);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <button
                                            className="btn btn-primary"
                                            type="submit"
                                            disabled={agentsLoading || !selectedAgent}
                                        >
                                            Save Changes
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                    {/* /Guardians List */}
                </div>
            </div>
        </div>
    );
};

export default MetaOnBoardStudents;
